#import "@/apollo/fragments/Campaign.gql"
#import "@/apollo/fragments/MasterTemplate.gql"

query CampaignEditor($campaignId: ID!) {
    campaign(campaignId: $campaignId) {
        ...Campaign
        languages
        client {
            _id
            id
            name
            imageProcessingEnabled
            connectModuleEnabled
            creativeXPlatformSettings {
                enabled
                brandId
            }
        }
        groupFeedMappings {
            group
            feedUrl
            primaryKey
        }
        dcProfileId
    }
    editablesWithOverwritesByCampaign(campaignId: $campaignId) {
        editable {
            _id
            name
            type
            restricted
            layers {
                masterTemplateId
                value
            }
            defaultValues {
                masterTemplateId
                value
                editableGroups
                dimensions {
                    width
                    height
                }
            }
            publisherPlatform
        }
        overwrites {
            _id
            scope
            editableGroupValueIds
            masterTemplateId
            language
            value
            modified
            settings
            mediaItem {
                id
                url
                name
                type
                folderId
                overwriteId
                persistentKey
                resizeSettings
                info {
                    contentLength
                    contentType
                    createdBy
                    created
                    modified
                }
            }
        }
    }
    editableGroupsByCampaign(campaignId: $campaignId) {
        name
        editables {
            _id
            name
            type
            restricted
            layers {
                masterTemplateId
                value
            }
            defaultValues {
                masterTemplateId
                value
                editableGroups
                dimensions {
                    width
                    height
                }
            }
            publisherPlatform
        }
        editableGroupValues {
            _id
            value
        }
    }
    masterTemplatesByCampaign(campaignId: $campaignId) {
        ...MasterTemplate
        parentId
        parentWidth
        parentHeight
    }
}
